import { DialogContent, styled } from '@mui/material';

const StyledDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '1.25rem !important',
  width: '31.25rem',
});

export default StyledDialogContent;
